export const ORGANIZATION_SETUP_WIZARD_PATH = '/onboarding/wizard?setup=1';

export const isPostDeleteOrganizationSetupSearch = (search: string): boolean =>
  new URLSearchParams(search).get('setup') === '1';
